import {OptionMenuController} from './option-menu.controller';
import template from './option-menu.template.html';

export const OptionMenuComponent = {
    controller: OptionMenuController,
    templateUrl: template,
    bindings: {
        optionSets: '<',
        onOptionSelected: '&',
        onBack: '&',
        onDone: '&'
    }
};



// WEBPACK FOOTER //
// ./src/js/components/option-menu/option-menu.component.js